import type React from 'react';
import {useEffect, useRef, useState} from 'react';
import {MdExpandLess, MdExpandMore} from 'react-icons/md';
import {cn} from '../../../../../../lib/classname';

export type SelfPRSectionProps = {
  pr: string;
  maxLines?: number;
};

export const SelfPRSection: React.FC<SelfPRSectionProps> = ({
  pr,
  maxLines = 3,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [showToggle, setShowToggle] = useState(false);
  const textRef = useRef<HTMLDivElement>(null);
  const isEmpty = pr === '';

  useEffect(() => {
    if (isEmpty || !textRef.current) return;

    const element = textRef.current;
    const lineHeight = Number.parseInt(
      window.getComputedStyle(element).lineHeight,
    );
    const maxHeight = lineHeight * maxLines;

    // テキストの実際の高さが最大高さを超えているかチェック
    setShowToggle(element.scrollHeight > maxHeight);
  }, [maxLines, isEmpty]);

  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div className="flex-1">
      <div className="font-bold">自己PR</div>
      <div
        ref={textRef}
        className={cn('text-base', {
          'text-black-3': isEmpty,
        })}
        style={{
          display: '-webkit-box',
          WebkitLineClamp: isExpanded ? 'unset' : maxLines,
          WebkitBoxOrient: 'vertical',
          overflow: isExpanded ? 'visible' : 'hidden',
        }}
      >
        {isEmpty ? '未入力です' : pr}
      </div>
      {showToggle && !isEmpty && (
        <button
          type="button"
          onClick={toggleExpanded}
          className="flex items-center gap-1 text-primary text-sm mt-1 hover:underline"
        >
          <span>{isExpanded ? '閉じる' : 'もっとみる'}</span>
          {isExpanded ? <MdExpandLess size={16} /> : <MdExpandMore size={16} />}
        </button>
      )}
    </div>
  );
};
